import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spin, Switch } from 'antd';
import AdaptChart from './AdaptChart';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import ExportUtil from '../../../../common/ExportUtil';
import { DefaultParams } from '../../constants/finance';

class ChartBox extends PureComponent {
    static contextTypes = {
        activeKey: PropTypes.string,
        handleExpand: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            loading: false,
            showLegend: false
        };
    }

    componentDidMount() {
        if (this.props.params.year) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.loadData();
        }
    }

    loadData = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { areaParams, statisticDate, hasCheckedArea, investigationMedicineType = [], ...rest } = params;
        this.setState({ loading: true });
        Fetch.post(API_URL.dashboard.queryGraphByType, {
            moduleType,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
            ...rest,
            ...areaParams,
            ...DefaultParams[activeKey]
        }).then(res => {
            this.setState({
                data: res,
                loading: false
            });
        });
    }

    handleExport = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { areaParams, statisticDate, hasCheckedArea, ...rest } = params;
        ExportUtil.export({
            moduleType,
            ...rest,
            ...areaParams,
            tableType: activeKey,
            ...DefaultParams[activeKey]
        }, null, API_URL.dashboard.exportGraphByType)
    }

    handleChange = (checked) => {
        this.setState({ showLegend: checked });
    }

    render() {
        const { handleExpand } = this.context;
        const { title, chartTypes = [], unit, toType } = this.props;
        const { loading, showLegend, data } = this.state;
        return (
            <div className="flexItem outer">
                <Spin spinning={loading}>
                    <div className="chartHeader">
                        <div className="modTitle">
                            <span>{title}</span>
                            <div className="legendContainer" style={{ display: 'inline-block', fontWeight: 'normal', color: '#999',marginLeft:"5px" }}>
                                <Switch size="small" checked={showLegend} onChange={this.handleChange} 
                                style={{marginBottom:"2px"}}/>
                                <span className="text">{!showLegend?"图例隐藏":"图例显示"}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <AdaptChart
                            data={data}
                            unit={unit}
                            filename={title}
                            showLegend={showLegend}
                            chartTypes={chartTypes}
                            onExport={this.handleExport}
                        />
                    </div>
                </Spin>
                <div className="footer">
                    { toType && <a className="more" onClick={() => handleExpand(toType)}>MORE</a> }
                </div>
            </div>
        );
    }
}

export default ChartBox;


// WEBPACK FOOTER //
// ./src/components/homePage/FinanceIndicatorAnalysis/components/ChartBox.js